import { Component, OnInit, ViewChild } from '@angular/core';
import {animate, state, style, transition, trigger} from '@angular/animations';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import {TranslateService} from '@ngx-translate/core';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import {MatPaginator} from '@angular/material/paginator';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import * as backInter from 'app/auth/auth-data.model';
//SERVICE
import { ODSService } from "../services/ods.service";
///IDIOMAS
import { lang_perfiles } from 'app/idiomas/i18n/perfiles/perfiles.lang';
import { lang_modales } from 'app/idiomas/i18n/modales/modales.lang';


export interface PeriodicElement {
  name: string;
  tipoen:string;
  numcol: number;
  totalco: number;
  totalfa: number;
  totalfin: number;

}
const ELEMENT_DATA: PeriodicElement[] = [
  {name: 'Gamesa',tipoen:'Medir', numcol: 100, totalco: 50, totalfa: 50, totalfin: 50},
  {name: 'Alpura',tipoen:'Medir', numcol: 80, totalco: 50, totalfa:  30, totalfin: 70},
  {name: 'Bimbo',tipoen:'Pulsecheck', numcol: 60, totalco: 60, totalfa: 0, totalfin: 100},
  {name: 'Pepsico',tipoen:'Pulsecheck', numcol: 40, totalco: 30, totalfa:  10, totalfin: 75},
  {name: 'Coca-cola',tipoen:'Certificar', numcol: 20, totalco: 10, totalfa:  10, totalfin: 50},
  {name: 'Famsa',tipoen:'Certificar', numcol: 10, totalco: 5, totalfa:  5, totalfin: 50},
  {name: 'Aurrera',tipoen:'Norma35', numcol: 5, totalco: 5, totalfa:  0, totalfin: 100},

];

@Component({
  selector: 'app-auditoria-auto',
  templateUrl: './auditoria-auto.component.html',
  styleUrls: ['./auditoria-auto.component.scss'],
})
export class AuditoriaAutoComponent implements OnInit {
@ViewChild(MatSort, {static: true}) sort: MatSort;
@ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  cargando:boolean;
  institutes : any;
  validacion:boolean=false;
  encuestasActivas:backInter.getEncuestasActivas;
  datosTabla:backInter.getEncuestasActivas;


  displayedColumns: string[] = ['name','tipoen','numcol','totalco','totalfa','totalfin','acciones'];
  dataSource: MatTableDataSource<backInter.encuestasActivas>;
  id:any;
  entrada:boolean=false;
  institutoActomatic:number;

  constructor(
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private translateSrv: TranslateService,
    private activatedRoute:ActivatedRoute,
    private router: Router,
    private odsService: ODSService,
  ) {
    lang_perfiles.forEach((locale) => {
    this._fuseTranslationLoaderService.loadTranslations(locale);
    });

  }

  ngOnInit() {
     this.getInstituteArray();
   }

applyFilter(event: Event) {
   const filterValue = (event.target as HTMLInputElement).value;
   this.dataSource.filter = filterValue.trim().toLowerCase();

 }
public getInstituteArray() {
   this.odsService.getInstituteArray()
   .subscribe(response => {

    let result: Institute[] = response['Institutos'];
    this.institutes = result;
    console.log(result);

   }, error => {
     console.log("error", error);
   })
 }


 validarInstituto(valor:number){
   console.log(valor);

 this.getconsultarencuestasActivas(valor);
 if(valor>=1){
 this.validacion=true;
  }
 else{
 this.validacion=false;
 }
}

 getconsultarencuestasActivas(institutoId:number){
   this.institutoActomatic=institutoId;
   this.cargando = true;
   let datos={institutoId:institutoId};
   // console.log(datos);
    this.entrada=false;
   this.odsService.getEncuestasActivas(datos).subscribe((res:backInter.getEncuestasActivas) =>{
     this.cargando = false;

     console.log(res);
     this.datosTabla=res;
     this.dataSource = new MatTableDataSource(res.companies);
     this.dataSource.sort=this.sort
     this.dataSource.paginator = this.paginator;



     // this.entrada=true;
     // this.Automatic();

   });


 }


 navigateTo(ruta,id_surveycon,productoId,token_config,companyName,productName){
   console.log('id_surveycon',id_surveycon);
   console.log('productoId',productoId);

   localStorage.setItem('configurationID', id_surveycon);

   localStorage.setItem('tokenConfig', token_config);
   localStorage.setItem('CompanyName', companyName);
   localStorage.setItem('ProductName', productName);

   this.odsService.getDatosEmpresaAuditoria(token_config).subscribe((res:any) =>{
 console.log('res',res);
 localStorage.setItem('productoID', productoId);
     this.router.navigate([ruta]);

   });
 }
//
//  Automatic(){
//    if(this.entrada){
//    this.id = setInterval(() => {
//           this.getconsultarencuestasActivas(this.institutoActomatic);
//         }, 7000);
//         }
//
//
// }
// ngOnDestroy(){
//   if (this.id) {
//     clearInterval(this.id);
//   }
// }
}
export interface Institute {
  numInstituto: number;
  regionInstituto: string;
}
